import { Injectable, } from '@angular/core';
import { catchError, map, retry } from 'rxjs/operators';
import { Observable, throwError, of } from 'rxjs';
import { HttpClientModule,HttpHeaders,HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlPreviewResponse } from '../models/gl-preview.model';


@Injectable({
	providedIn: 'root'
})

export class VendorService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private globalSearchService: GlobalSearchService, private http: HttpClient,private _configSvc: RuntimeConfigLoaderService) {
		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});
		// Prime from BehaviorSubject so getApiKey() has user before first emission in edge cases
		this.user = this.globalSearchService.user.value ?? this.user;

		this.globalSearchService.configsubscription.subscribe((result: any) => {
			this.config = result;
		});
	}


	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type':	'application/json',
		})
	};


	public vendorService(id: any) {

	}

	public searchVendorHistory(data: any) {
		const method = 'vendor/history';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getAge() {
		const method = 'vendor/ageing';
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Open Payables — every supplier document still carrying a balance, across all
	 * vendors, for an invoice-date range with an optional "due by" cut-off.
	 *
	 * Params travel on the query string because setEndPoint has already appended
	 * one; blank values are dropped so the server sees an absent filter rather than
	 * an empty string it has to special-case.
	 */
	public getOpenPayables(params: any) {
		let method = 'vendor/openpayables/report';
		Object.keys(params || {}).forEach((k) => {
			const v = params[k];
			if (v === null || v === undefined || v === '') { return; }
			method += '&' + k + '=' + encodeURIComponent(v);
		});
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError('vendor/openpayables/report', { success: false }))
		);
	}

	/** Vendors carrying an open balance — the Open Payables vendor picker. */
	public getOpenPayablesFilters() {
		const method = 'vendor/openpayables/filters';
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, { success: false, vendors: [] }))
		);
	}

	public getDashBoard(options?: { as_of_date?: string }) {
		let method = 'vendor/dashboard';
		const d = options?.as_of_date;
		if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
			method += '&as_of_date=' + encodeURIComponent(d);
		}
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError((err) => {
				// The dashboard cards (overdue, ready-to-pay, payments, brand
				// disbursements, as-of) subscribe with no error handler, so an
				// HTTP error or PHP 500 would otherwise leave them spinning
				// forever. Degrade to an empty payload so they resolve to empty
				// states; the error is logged for diagnosis.
				console.error('vendor/dashboard request failed', err);
				return of({ payments: [], aged: [], readyToPay: [], brandDisbursements: [] });
			})
		);
	}

	public getTop100Vendors(data: any) {
		const method = 'vendor/top100';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public checkInvoiceReference(supplierid: string, reference: string) {
		const method = 'vendor/invoice/checkreference&supplierid=' + encodeURIComponent(supplierid) + '&reference=' + encodeURIComponent(reference);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public checkCreditReference(supplierid: string, reference: string) {
		const method = 'vendor/credit/checkreference&supplierid=' + encodeURIComponent(supplierid) + '&reference=' + encodeURIComponent(reference);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public createInvoice(invoicedata: any) {
		const method = 'vendor/invoice/create';
		return this.http.post(this.setEndPoint(method), invoicedata, this.httpOptions).pipe(
			catchError(this.handleError(method, invoicedata))
		);
	}

	public editUnsettledTransaction(data: any) {
		const method = 'vendor/invoice/editunsettled';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	/** Correct a PO line's unit price (we accepted the vendor's invoice price over a bad PO price). */
	public updatePoLinePrice(podetailitem: any, unitprice: number) {
		const method = 'vendor/invoice/updatepoprice';
		return this.http.post(this.setEndPoint(method), { podetailitem, unitprice }, this.httpOptions).pipe(
			catchError(this.handleError(method, { podetailitem, unitprice }))
		);
	}

	public previewInvoiceGl(payload: any) {
		const method = 'vendor/invoice/glpreview';
		return this.http.post<GlPreviewResponse>(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	/* ---- Vendor statement reconciliation (apir/vendor/statement) ---- */
	public stmtRun(data: any) {
		const method = 'vendor/statement/run';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}
	public stmtGetRun(runId: number) {
		return this.http.get(this.setEndPoint('vendor/statement/getrun&run_id=' + runId));
	}
	public stmtIssueSummary(runId: number) {
		return this.http.get(this.setEndPoint('vendor/statement/issuesummary&run_id=' + runId));
	}
	public stmtLines(runId: number, issue?: string) {
		let m = 'vendor/statement/lines&run_id=' + runId;
		if (issue) { m += '&issue=' + encodeURIComponent(issue); }
		return this.http.get(this.setEndPoint(m));
	}
	public stmtFixes(runId: number) {
		return this.http.get(this.setEndPoint('vendor/statement/fixes&run_id=' + runId));
	}
	public stmtPayables(supplierno: string, openOnly = false, runId?: number) {
		let m = 'vendor/statement/payables&supplierno=' + encodeURIComponent(supplierno);
		if (runId) { m += '&run_id=' + runId; } else if (openOnly) { m += '&open=1'; }
		return this.http.get(this.setEndPoint(m));
	}
	public stmtRuns(supplierno: string) {
		return this.http.get(this.setEndPoint('vendor/statement/runs&supplierno=' + encodeURIComponent(supplierno)));
	}
	public stmtExport(runId: number, tab = 'all') {
		return this.http.get(this.setEndPoint('vendor/statement/export&run_id=' + runId + '&tab=' + encodeURIComponent(tab || 'all')));
	}
	public stmtConfigGet(supplierno: string) {
		return this.http.get(this.setEndPoint('vendor/statement/configget&supplierno=' + encodeURIComponent(supplierno)));
	}
	public stmtConfigSave(data: any) {
		const method = 'vendor/statement/configsave';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}
	public stmtApplyFix(data: any) {
		const method = 'vendor/statement/applyfix';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}
	public stmtRollbackFix(data: any) {
		const method = 'vendor/statement/rollbackfix';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}
	public stmtRescan(runId: number) {
		const method = 'vendor/statement/rescan';
		return this.http.post(this.setEndPoint(method), { run_id: runId }, this.httpOptions).pipe(catchError(this.handleError(method, { run_id: runId })));
	}
	public stmtArchiveRun(data: any) {
		const method = 'vendor/statement/archiverun';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	/* ---- Move transactions between vendors (apir/vendor/movetransactions) ---- */
	public vendorSearch(input: any) {
		const method = 'vendor/search';
		return this.http.post(this.setEndPoint(method), input, this.httpOptions).pipe(catchError(this.handleError(method, input)));
	}
	public getSupplierTransactions(supplierid: any) {
		const method = 'vendor/movetransactions/list&supplierid=' + encodeURIComponent(supplierid);
		return this.http.get(this.setEndPoint(method));
	}
	public moveSupplierTransactions(data: any) {
		const method = 'vendor/movetransactions/move';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	public createCredit(data: any) {
		const method = 'vendor/credit/create';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public previewCreditGl(payload: any) {
		const method = 'vendor/credit/glpreview';
		return this.http.post<GlPreviewResponse>(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	public createReturn(data: any) {
		const method = 'vendor/return/create';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public updateVendorContacts(settings: any) {
		const method = 'vendor/updatevendorcontacts';
		return this.http.post(this.setEndPoint(method), settings, this.httpOptions).pipe(catchError(this.handleError(method, settings))
		);
	}
	public updateVendorNotes(settings: any) {
		const method = 'vendor/updatenotes';
		return this.http.post(this.setEndPoint(method), settings, this.httpOptions).pipe(catchError(this.handleError(method, settings))
		);
	}

	public updateVendor(input: any) {
		const method = 'vendor/update';
		return this.http.post(this.setEndPoint(method), { vendordata: input }, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getVendor(vendorid: any, date?: string) {
		// Optional `date` → server returns duedate_iso computed from that invoice date
		// + the vendor's terms (used to prepopulate the apply-to-vendor payment panel).
		// encodeURIComponent so vendor ids containing & (e.g. "YA&D" Yulee Art & Designs)
		// aren't truncated at the & when appended to the query string.
		let method = 'vendor/read&supplierid='+encodeURIComponent(vendorid);
		if (date) { method += '&date=' + encodeURIComponent(date); }
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorTransactions(data: any) {
		const method = 'vendor/transactions';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getDispensaryOpenSummary(supplierid: string, debtorno: string) {
		const method = `vendor/dispensaryOpenSummary&supplierid=${encodeURIComponent(supplierid)}&debtorno=${encodeURIComponent(debtorno)}`;
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, { supplierid, debtorno }))
		);
	}

	public getBrandPaymentLinks(supplierid: string, includeSettled = false) {
		const method = `vendor/brandPaymentLinks&supplierid=${encodeURIComponent(supplierid)}&include_settled=${includeSettled ? '1' : '0'}`;
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, { supplierid, includeSettled }))
		);
	}

	public reverseTransaction(transid: any, reason: any, bypass:any = false) {
		const method = 'purchasing/reversal';
		const userid = this.getEffectiveUserid();
		return this.http.post(this.setEndPoint(method), { transid: transid, reason: reason, userid: userid, bypass: bypass }, this.httpOptions).pipe(
			catchError(this.handleError(method, { transid: transid }))
		);
	}

	/** Same source as vendor invoice/credit; URL query userid must stay in sync for APIs that only read GET. */
	private getEffectiveUserid(): string {
		try {
			const u = this.globalSearchService.user?.value ?? this.user;
			if (u && typeof u === 'object' && !Array.isArray(u)) {
				const fromNested = u.user?.userid;
				if (fromNested != null && String(fromNested).trim() !== '') {
					return String(fromNested).trim();
				}
				if (u.userid != null && String(u.userid).trim() !== '') {
					return String(u.userid).trim();
				}
				if (u.user_id != null && String(u.user_id).trim() !== '') {
					return String(u.user_id).trim();
				}
			}
			if (typeof localStorage !== 'undefined') {
				const raw = localStorage.getItem('user');
				if (raw) {
					const p = JSON.parse(raw);
					if (p?.user?.userid != null && String(p.user.userid).trim() !== '') {
						return String(p.user.userid).trim();
					}
					if (p?.userid != null && String(p.userid).trim() !== '') {
						return String(p.userid).trim();
					}
				}
			}
		} catch {
			/* ignore */
		}
		return '';
	}

	public getDailyTransactions(data: any) {
		const method = 'vendor/getdailytransactions';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('vendor/getdailytransactions', data))
		);
	}

	/**
	 * Active vendors only unless options.inc_disabled. Prefer getVendorsPost for full control.
	 */
	public getVendors(options?: { inc_disabled?: boolean }) {
		return this.getVendorsPost({
			inc_disabled: options?.inc_disabled === true,
		});
	}

	/** vendor/search POST: keywords optional; inc_disabled true includes suppliers.active = 0 */
	public getVendorsPost(data: { keywords?: string; inc_disabled?: boolean } = {}) {
		const method = 'vendor/search';
		const payload = {
			keywords: data.keywords != null ? String(data.keywords) : '',
			inc_disabled: data.inc_disabled === true,
		};
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	public getVendorSearch(keywords: any, inc_disabled = false) {
		return this.getVendorsPost({
			keywords: keywords != null ? String(keywords) : '',
			inc_disabled: inc_disabled === true,
		});
	}

	public getVendorTypes() {
		const method = 'vendor/getvendortypes';
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorItems(vendorid){
		 const method = 'vendor/purchdata&supplierid='+vendorid;
		 return this.http.get(this.setEndPoint(method));
	}

	public deleteVendor(vendorid){
		 const method = 'vendor/remove&supplierid='+vendorid;
		 return this.http.get(this.setEndPoint(method));
	}

	public saveVendor(vendordata){
		const method = 'vendor/save';
		return this.http.post(this.setEndPoint(method), { vendordata: vendordata }, this.httpOptions).pipe(
			catchError(this.handleError(method, vendordata))
		);
	}

	public uploadVendorAttachment(transId: number, payload: { content: string; name: string; mime: string }) {
		const method = 'vendor/attachment/upload';
		const body = { ...payload, transid: transId };
		const options = { ...this.httpOptions, timeout: 120000 };
		return this.http.post(this.setEndPoint(method), body, options).pipe(
			map((res: any) => {
				if (res && res.success !== true) {
					throw new Error('Attachment upload failed');
				}
				return res;
			}),
			catchError(this.handleError(method, body))
		);
	}

	public getVendorAttachments(transId: number) {
		const method = 'vendor/attachment/getList&transid=' + transId;
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public getVendorAttachmentDownloadUrl(attachmentId: number): string {
		return this.getApi() + 'vendor/attachment/download&id=' + attachmentId + this.getApiKey();
	}

	public getVendorAttachmentViewUrl(attachmentId: number): string {
		return this.getApi() + 'vendor/attachment/download&id=' + attachmentId + '&inline=1' + this.getApiKey();
	}

	public uploadVendorDocument(supplierid: string, payload: { content: string; name: string; mime: string }) {
		const method = 'vendor/documents/upload';
		const body = { ...payload, supplierid };
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	public getVendorDocuments(supplierid: string) {
		const method = 'vendor/documents/list&supplierid=' + encodeURIComponent(supplierid);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public computeDueDate(data: { invoiceDate: string; daysbeforedue: number; dayinfollowingmonth: number; statementperiods: number }): Observable<any> {
		const method = 'vendor/duedate/compute';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public deleteVendorDocument(supplierid: string, idOrLink: number | string) {
		const method = 'vendor/documents/delete';
		const body = typeof idOrLink === 'number'
			? { id: idOrLink, supplierid }
			: { supplierid, link: idOrLink };
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi()+method+this.getApiKey()
	}

	/** Full URL to the MOOV brand per-payment Payout Breakdown as a PDF (new tab). */
	public getBrandStatementPdfUrlByPayment(paymentId: number | string) {
		const method = 'vendor/payments/brandstatement&payment_id=' + encodeURIComponent(String(paymentId)) + '&format=pdf';
		return this.setEndPoint(method);
	}

	/** Full URL to the MOOV brand running Statement of Account as a PDF (new tab). */
	public getBrandAccountPdfUrl(supplierid: number | string) {
		const method = 'vendor/payments/brandaccount&supplier_id=' + encodeURIComponent(String(supplierid)) + '&format=pdf';
		return this.setEndPoint(method);
	}

	/** MOOV brand per-payment Payout Breakdown PDF as a Blob (for a forced download). */
	public getBrandStatementPdfBlobByPayment(paymentId: number | string): Observable<Blob> {
		return this.http.get(this.getBrandStatementPdfUrlByPayment(paymentId), { responseType: 'blob' }).pipe(
			catchError(this.handleError('vendor/payments/brandstatement', new Blob()))
		);
	}

	/** MOOV brand running Statement of Account PDF as a Blob (for a forced download). */
	public getBrandAccountPdfBlob(supplierid: number | string): Observable<Blob> {
		return this.http.get(this.getBrandAccountPdfUrl(supplierid), { responseType: 'blob' }).pipe(
			catchError(this.handleError('vendor/payments/brandaccount', new Blob()))
		);
	}

	/** MOOV brand per-payment Payout Breakdown XLSX as a Blob (for a forced download). */
	public getBrandStatementXlsxBlobByPayment(paymentId: number | string): Observable<Blob> {
		const method = 'vendor/payments/brandstatement&payment_id=' + encodeURIComponent(String(paymentId)) + '&format=xlsx';
		return this.http.get(this.setEndPoint(method), { responseType: 'blob' }).pipe(
			catchError(this.handleError('vendor/payments/brandstatement', new Blob()))
		);
	}

	/** MOOV brand running Statement of Account XLSX as a Blob (for a forced download). */
	public getBrandAccountXlsxBlob(supplierid: number | string): Observable<Blob> {
		const method = 'vendor/payments/brandaccount&supplier_id=' + encodeURIComponent(String(supplierid)) + '&format=xlsx';
		return this.http.get(this.setEndPoint(method), { responseType: 'blob' }).pipe(
			catchError(this.handleError('vendor/payments/brandaccount', new Blob()))
		);
	}

	/** MOOV brand per-payment Payout Breakdown as JSON ({ success, html }) for the preview modal / PDF export. */
	public getBrandStatementByPayment(paymentId: number | string): Observable<any> {
		const method = 'vendor/payments/brandstatement&payment_id=' + encodeURIComponent(String(paymentId));
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		const uid = encodeURIComponent(this.getEffectiveUserid());
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + uid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey='+this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return throwError(() => error);
		};
	}
}
